<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/share-link.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">{{ 'app.components.linkingWizard.title' | translate }}</h2>
      <p class="parent-dialog__subtitle">{{ 'app.components.linkingWizard.subTitle' | translate }}</p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.components.linkingWizard.close' | translate"
    (click)="discard()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<mat-dialog-content class="parent-dialog__body">
  @if (familyBlocked()) {
    <section class="parent-dialog__section">
      <p class="parent-dialog__hint">
        {{ 'app.components.linkingWizard.familyBlockedBody' | translate }}
      </p>
    </section>
  } @else if (step() === 'choose') {
    <section class="parent-dialog__section">
      <span class="parent-dialog__section-label">
        {{ 'app.components.linkingWizard.chooseFlow' | translate }}
      </span>
      <p class="parent-dialog__hint">
        {{ 'app.components.linkingWizard.chooseFlowHint' | translate }}
      </p>
      <button type="button" class="link-kid__option" (click)="chooseCreateKid()">
        <span class="link-kid__option-icon" aria-hidden="true">
          <img src="/public/svgs/add-kid.svg" alt="" width="18" height="18" />
        </span>
        <span class="link-kid__option-copy">
          <span class="link-kid__option-title">
            {{ 'app.components.linkingWizard.createNew' | translate }}
          </span>
        </span>
        <img src="/public/svgs/chevron-right.svg" alt="" width="16" height="16" aria-hidden="true" />
      </button>
    </section>
  }

  @if (step() === 'existing') {
    <section class="parent-dialog__section">
      <span class="parent-dialog__section-label">
        {{ 'app.components.linkingWizard.channelTitle' | translate }}
      </span>
      <div class="link-kid__channels">
        <button
          type="button"
          class="link-kid__channel"
          [class.link-kid__channel--active]="selectedChannel() === 'QR'"
          (click)="setChannel('QR')"
        >
          {{ 'app.components.linkingWizard.channels.qr' | translate }}
        </button>
        <button
          type="button"
          class="link-kid__channel"
          [class.link-kid__channel--active]="selectedChannel() === 'DEEP_LINK'"
          (click)="setChannel('DEEP_LINK')"
        >
          {{ 'app.components.linkingWizard.channels.deepLink' | translate }}
        </button>
        <button
          type="button"
          class="link-kid__channel"
          [class.link-kid__channel--active]="selectedChannel() === 'CODE'"
          (click)="setChannel('CODE')"
        >
          {{ 'app.components.linkingWizard.channels.code' | translate }}
        </button>
      </div>
    </section>

    @if (generated(); as invite) {
      <section class="link-kid__result">
        @if (selectedChannel() === 'QR' && qrImageBase64()) {
          <div class="link-kid__qr">
            <img
              [src]="qrImageBase64()"
              [alt]="'app.components.linkingWizard.result.qrAlt' | translate"
            />
          </div>
        }
        @if (selectedChannel() === 'DEEP_LINK') {
          <p class="link-kid__result-row">
            <span class="link-kid__result-label">
              {{ 'app.components.linkingWizard.result.deepLinkLabel' | translate }}
            </span>
            {{ invite.deepLink }}
          </p>
        }
        @if (selectedChannel() === 'CODE') {
          <p class="link-kid__result-row">
            <span class="link-kid__result-label">
              {{ 'app.components.linkingWizard.result.codeLabel' | translate }}
            </span>
            {{ invite.code }}
          </p>
        }
      </section>
    }
  }

  @if (infoMessage()) {
    <p class="link-kid__info">{{ infoMessage() }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="parent-dialog__actions parent-dialog-actions">
  @if (familyBlocked()) {
    <app-parent-button variant="ghost" (clicked)="discard()">
      {{ 'app.components.linkingWizard.close' | translate }}
    </app-parent-button>
    <app-parent-button variant="primary" (clicked)="startParentVerification()">
      {{ 'app.components.linkingWizard.familyBlockedCta' | translate }}
    </app-parent-button>
  } @else if (step() === 'existing') {
    <app-parent-button variant="ghost" (clicked)="backToChoose()">
      {{ 'app.components.linkingWizard.back' | translate }}
    </app-parent-button>
  } @else {
    <app-parent-button variant="ghost" (clicked)="discard()">
      {{ 'app.components.linkingWizard.close' | translate }}
    </app-parent-button>
  }

  @if (step() === 'existing' && generated()) {
    <app-parent-button variant="primary" (clicked)="shareInvite()">
      <img src="/public/svgs/share-link.svg" alt="" width="14" height="14" aria-hidden="true" />
      {{ 'app.components.linkingWizard.result.share' | translate }}
    </app-parent-button>
  }
</mat-dialog-actions>
